/**
 * @ngdoc service
 * @name settings.factory:editProfile
 *
 * @description
 *
 */
angular
    .module('festzelt-os.settings')
    .factory('editProfile', [
        '$state',
        ($state) => new EditProfileWorkflow($state)
    ]);

class EditProfileWorkflow {
    constructor($state) {
        this.state = $state;

        this.key = 'edit-profile';
        this.title = 'Edit Profile';
        this.level = 'highlight';
        this.icon = 'pencil';
    }

    action() {
        this.state.go('app.settings.profile-edit');
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/workflows/profile/edit-profile.js